import React from 'react'
import styled, { css } from 'styled-components'
import { Helmet } from 'react-helmet'

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* overflow-x: auto; */
  flex-shrink:0;
  flex-grow:1;
`

const StyledPageContent = styled.div`
  width: 100%;
  max-width: ${props => props.theme.maxPageContentWidth};
  font-family: ${props => props.bodyFontFamily};
`

const StyledPageTitle = styled.div`
  font-size: 3rem;
  text-align: center;
  line-height: 1;
`
const StyledPageSubtitle = styled.div`
  font-size: 1.5rem;
  text-align: center;
  ${props => props.subtitle && css`
    margin-top: 1rem;
  `}
`

const StyledPageHeader = styled.div`
  padding: 3rem;
  width: 100%;
  ${props => props.title && (!props.subtitle) && css`
    padding: 1rem;
    padding-bottom: 0rem;
  `}
  ${props => props.title && props.subtitle && css`
    padding: 1rem;
    ${StyledPageSubtitle}{
      margin-top: 0rem;
    }
  `}
  /* background: linear-gradient(transparent, ${props => props.theme.pageTopBleedColor}); */
`

const FullBleedPageContent = styled.div`
  width: 100%;
  font-family: ${props => props.bodyFontFamily};
  flex-grow:1;
`

const ContentHolder = ({ fullBleed, children }) => {
  if (fullBleed) {
    return <FullBleedPageContent>{ children }</FullBleedPageContent>
  } else {
    return <StyledPageContent>{ children }</StyledPageContent>
  }
}

export const Page = ({ title, subtitle, children, fullBleed }) => {
  const hasEitherTitleOrSubtitle = (title || subtitle)
  return (hasEitherTitleOrSubtitle) ? (
    <StyledPage>
      <Helmet>
        <title>{`Northeast Georgia History Center | ${title}`}</title>
        <meta name='description' content='The mission of the Northeast Georgia History Center at Brenau University is to preserve and share the history of northeast Georgia. Our exhibits, historic structures, educational programming, and events connect people to the past so that they may better understand the present. We continue our mission through donations big and small, the service of our Members and Volunteers, and patrons to the History Center. We hope to see you soon!' />
      </Helmet>
      <StyledPageHeader title={title} subtitle={subtitle}>
        <StyledPageTitle>{title}</StyledPageTitle>
        <StyledPageSubtitle>{subtitle}</StyledPageSubtitle>
      </StyledPageHeader>
      <ContentHolder fullBleed={fullBleed} >{children}</ContentHolder>
    </StyledPage>
  ) : (
    <StyledPage>
      <ContentHolder fullBleed={fullBleed}>{children}</ContentHolder>
    </StyledPage>
  )
}
